import { reactive, computed } from '@vue/composition-api'

import set from './set/'

export const stateDefault = {
  content: ``,
  action1: null,
  action2: null
}

export const state = reactive({
  ...stateDefault,

  value: computed(() => !!state.content)
})

export default () => {
  const methods = {
    set
  }

  return {
    state,
    ...methods
  }
}
